import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface LogInterface {
    prefix(prefix: string): LogInterface;
    debug(message: string, ...additional: unknown[]): void;
    info(message: string, ...additional: unknown[]): void;
    log(message: string, ...additional: unknown[]): void;
    warn(message: string, ...additional: unknown[]): void;
    error(message: string, ...additional: unknown[]): void;
    getLogs(): Observable<string>;
}

export const LogInstanceToken = new InjectionToken<LogInterface>('LogInterface');
